import { render, staticRenderFns } from "./RegistStageSunny.vue?vue&type=template&id=361006d1&scoped=true&"
import script from "./RegistStageSunny.vue?vue&type=script&lang=js&"
export * from "./RegistStageSunny.vue?vue&type=script&lang=js&"
import style0 from "./RegistStageSunny.vue?vue&type=style&index=0&id=361006d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361006d1",
  null
  
)

export default component.exports